import { VersionStatus } from "models/api/status"
import { Platform } from "models/api/platform"

export const DEFAULT_ERROR_TEXT = 'Что-то пошло не так ..'

export const PLATFORMS = [
  {
      id: Platform.Android,
      name: Platform.Android,
      label: Platform.Android
  },
  {
      id: Platform.Ios,
      name: Platform.Ios,
      label: Platform.Ios
  },
  {
    id: Platform.All,
    name: Platform.All,
    label: Platform.All
  },
]

export const STATUSES = [
  {
    id: VersionStatus.Active,
    name: VersionStatus.Active,
    label: 'active'
  },
  {
    id: VersionStatus.Blocked,
    name: VersionStatus.Blocked,
    label: VersionStatus.Blocked
  },
  {
    id: VersionStatus.Deprecated,
    name: VersionStatus.Deprecated,
    label: VersionStatus.Deprecated
  },
  {
    id: VersionStatus.Maintenance,
    name: VersionStatus.Maintenance,
    label: VersionStatus.Maintenance
  },
  {
    id: VersionStatus.Preview,
    name: VersionStatus.Preview,
    label: VersionStatus.Preview
  },
]

export const mainMenu = [
  {
    label: 'Версии',
    route: '/',
  },
  {
    label: 'Техническое обслуживание',
    route: '/maintenance',
  }
]

export const defaultPagination = {
  pageNumber: 1,
  pageSize: 25,
}

// Dates
const timeFormat = 'HH:mm';
const timeWithSecondsFormat = timeFormat + ':ss';
const dateFormat = 'yyyy-MM-dd';
const defaultDatetimeFormat = dateFormat + ' ' + timeFormat;
const datetimeFormat = dateFormat + "'T'" + timeFormat;
const datetimeWithSecondsFormat = dateFormat + "'T'" + timeWithSecondsFormat;

export { timeFormat, dateFormat, defaultDatetimeFormat, datetimeFormat, datetimeWithSecondsFormat, timeWithSecondsFormat };
